import langList from './langList';

export default {
  [langList.RU]: 'pik-group.ru',
  [langList.ENG]: 'pik-group.com',
};
